import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	// Delete savedFilterPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
	savedFilterPickerAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterPickerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// Delete savedFilterPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
	savedFilterPickerAriaLabel: {
		id: 'software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-aria-label',
		defaultMessage: 'Select an option',
		description: 'Label for a select',
	},
	savedFilterPickerPlaceholder: {
		id: 'software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder',
		defaultMessage: 'Select',
		description: 'Placeholder for a select',
	},
});
export default messages;
